import { URDFJoint, URDFRobot } from "urdf-loader";
import { ModelRenderer } from "../ModelRenderer";
import { Box, MenuItem, TextField, Typography } from "@mui/material";
import { PropValueLine } from "../common/PropValueLine";
import { ArmMotionMapper, MotionMapperType } from "../../models/Model";
import { useEffect, useState } from "react";
import { MREvents } from "../MREvents";
import { URDFRobotArmJoint } from "./URDFRobotArmJoint";
import { ObjectHighlighterButton } from "../common/ObjectHighlighterButton";

export function URDFRobotArmPropsPanel({
  mr,
  robot,
}: {
  mr: ModelRenderer;
  robot: URDFRobot;
}) {
  const [selectedJoint, setSelectedJoint] = useState<URDFJoint | null>(null);
  useEffect(() => {
    if (!robot) {
      return;
    }
    const model = mr.loader.model;
    setSelectedJoint(null);

    if (model.motionMapper.type !== MotionMapperType.RobotArm) {
      const armMotionMapper: ArmMotionMapper = {
        type: MotionMapperType.RobotArm,
        joints: {} as any,
      };
      model.motionMapper = armMotionMapper;
      mr.emitEvent(MREvents.ModelUpdated, model);
      mr.loader.adapt();
    }
  }, [robot]);
  return (
    <>
      <PropValueLine
        label="Joint"
        value={
          <>
            <TextField
              size="small"
              variant="standard"
              select
              value={selectedJoint ? selectedJoint.name : ""}
              onChange={(e) => {
                const jointName = e.target.value;
                const joint = robot.joints[jointName];
                if (joint) {
                  setSelectedJoint(joint);
                }
              }}
              sx={{ minWidth: "200px" }}
            >
              <MenuItem value="" key="none" disabled>
                Select Joint
              </MenuItem>
              {Object.values(robot.joints).map((joint) => (
                <MenuItem key={joint.name} value={joint.name}>
                  {joint.name}
                </MenuItem>
              ))}
            </TextField>
            <ObjectHighlighterButton object={selectedJoint as any} />
          </>
        }
      />
      {selectedJoint && (
        <URDFRobotArmJoint
          robot={robot}
          model={mr.loader.model}
          joint={selectedJoint}
        />
      )}
    </>
  );
}
